import React, { Component } from "react";
import { observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import LoadingImage from "../../../comum/components/LoadingImage";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import {Col, Row, Container, Button} from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { CollapseItemTableIndicator } from "../../../comum/components/CollapseItemTableIndicator";
import DetalhesAgServicos from "./DetalhesAgServicos";
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";
import { IconeProibido, IconeEditar} from "../../../comum/components/Icones";
import ModalForm from "../../../comum/components/ModalForm";
import ModalAviso from "../../../comum/components/ModalAviso";

@observer
export class TabelaAgServico extends Component {
    constructor(props) {
        super(props)
        this.controller = this.props.controller;
        this.controllerAgServicos = this.props.controllerAgServicos;

        this.state = {
            showModalQuantidadeContainer: false
        }
        window.addEventListener('scroll', HeaderTableFixed);

        this.addColDetalhes();
    }

    handleCancelarAgendamento = async (agendServId) => {
        await this.controller.setIdRow(agendServId);
        this.controller.modalCancelar = "CANCELAR";
    };

    modalConfirmaCancelar = () => {
        if (this.controller.modalCancelar)
            return <ModalForm   labelCancelar="NÃO"
                                labelConfirmar="SIM"
                                salvando={false}
                                onClickCancelar={ () => this.controller.fechaModais() }
                                onClickSalvar={ () => this.controller.cancelarAgendamento() }>
                    { this.controller.modalCancelar === "CANCELAR" && <h2>Deseja realmente cancelar o Agendamento?</h2> }
                </ModalForm>
    };

    erroCancelarAgendamento = () => {
        if (this.controller.mensagemErro)
        {
            return  <ModalAviso onClickFechar={ () => this.controller.mensagemErro = "" }>                
                        <h2>{ this.controller.mensagemErro }</h2>
                    </ModalAviso>
        }
    };


    handleAbrirEditar = (row) => {
        console.log('row', row)
        this.controllerAgServicos.editar(row.AgendServId, row.AgendGrupoServId, row.AgendTipoServId,row.Placa, row.HoraAgend, row.DatAgend); 
    };

    addColDetalhes = () => {
        this.controller.colunas.push({
            dataField: 'acao',
            isDummyField: true,
            text: '',
            formatter: (cell, row) => {
                return <div>
                        { !["CANCELADO", "ATENDIDO"].includes(row.DscIndStatus.toUpperCase()) &&
                            <div>  
                                <a onClick={() => this.handleCancelarAgendamento(row.AgendServId)} >
                                        <IconeProibido title={"Cancelar"} tamanho="lg" className="m-2" />
                                </a>
                                &nbsp;&nbsp;
                                <a onClick={() => this.handleAbrirEditar(row)} >
                                        <IconeEditar title={"Editar"} tamanho="lg" className="m-2" />
                                </a>
                            </div>
                        }                        
                    </div>
            },
            cardFormatter: (cell, row) => {
                return <Row>
                        { !["CANCELADO"].includes(row.DscIndStatus.toUpperCase()) &&
                            <Col sm={12}>
                                <Button className="btn-com-bordas-primary" onClick={() => this.handleAbrirEditar(row)} >Cancelar</Button>                            
                                <Button className="btn-com-bordas-primary" onClick={() => this.handleAbrirEditar(row)} >Editar</Button>
                            </Col>
                        }
                    </Row>
            }
        });
    };

    render() {
        const detalhesRow = {
            renderer: row => (
                <Row>
                    <DetalhesAgServicos titulo="Outros dados" colunas={this.controller.colunas} row={row} />
                </Row>
            ),
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Detalhes",
            onExpandAll: (isExpandAll, results, e) => {
                e.PreventDefault();
            },
            expandColumnPosition: 'right',
            expandColumnRenderer: ({ expanded }) => {
                return (
                    <CollapseItemTableIndicator expanded={expanded} />
                );
            }
        };

        return (
            <Container fluid className="tabela-container">
                {this.controller.loading ? <LoadingImage />

                    : <React.Fragment>
                        {(!this.controller.items.length > 0)
                            ? <Row>
                                <Col xs={12}>
                                    <span className="mensagem-filtrar">
                                        {this.controller.tableMessage}
                                    </span>
                                </Col>
                            </Row>
                            :

                            <InfiniteScroll
                                dataLength={this.controller.items.length}
                                next={() => this.controller.loadNextTurn()}
                                hasMore={this.controller.hasMore}
                                loader={<LoadingImage />}
                            >
                                <ToolkitProvider
                                    keyField="AgendServId"
                                    data={[...this.controller.items]}
                                    columns={[...this.controller.colunas]} >
                                    {props => (
                                        <div id="tableHeaderFixed">
                                            {
                                                <BootstrapTable bootstrap4
                                                    striped
                                                    bordered={false}
                                                    noDataIndication={() => this.controller.noData}
                                                    classes="tabela tabela-layout cabotagem"
                                                    expandRow={detalhesRow}
                                                    {...props.baseProps} />

                                            }
                                        </div>)
                                    }
                                </ToolkitProvider>
                            </InfiniteScroll>}
                    </React.Fragment>}
                    <React.Fragment>
                        {this.modalConfirmaCancelar() }
                        {this.erroCancelarAgendamento()}
                    </React.Fragment>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamentoservicosTotal/visualizar/components/TabelaAgServicos.js